<script>
  import {onMount} from 'svelte';
  let { item } = $props();

  onMount(async () => {
    refreshFsLightbox();
  });
</script>

<div class="gallery-item -movie">
<a href='{item.gallery.youtube}' data-fslightbox="youtube" data-type="youtube" class="movie"><span class="icon movie-icon"></span></a>
</div>